import React, { useState, useRef, useEffect } from "react";
import UpcomingIcon from "@mui/icons-material/Upcoming";
import SendIcon from "@mui/icons-material/Send";
import SearchIcon from "@mui/icons-material/Search";
import Cookies from "js-cookie";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { cloneDeep, isEqual } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import InboxIcon from "@mui/icons-material/Inbox";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const AdminWhatsapp = () => {
  const scrollContainerRef = useRef();

  const [screenWidth, setScreenWidth] = useState("1920");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [messages, setMessages] = useState([]);
  const [activeConversation, setActiveConversation] = useState(null);
  const [messageInput, setMessageInput] = useState("");
  const [messageHover, setMessageHover] = useState(null);
  const [showArchive, setShowArchive] = useState(false);

  function convertDateString(inputString) {
    // Parse the input string to obtain a Date object
    const dateObject = new Date(inputString);

    // Format the date
    const optionsDate = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = dateObject.toLocaleDateString("en-US", optionsDate);

    // Format the time
    const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };
    const formattedTime = dateObject.toLocaleTimeString("en-US", optionsTime);

    return { date: formattedDate, time: formattedTime };
  }

  const inputRef = useRef(null);

  const sendMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/sendWhatsAppMessage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            to: messages[activeConversation].mobile,
            message: messageInput,
          }),
        }
      );
      if (response.status === 200) {
        getMessage();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // keep these in component state
  const [since, setSince] = useState(null);
  const [afterId, setAfterId] = useState(null);

  const getMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/whatsapp/getAllWhatsappMessage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            // send either since or after_id (after_id is very cheap)
            after_id: afterId || undefined,
            // or since: since || undefined,
            // limit: 2000, // optionally tune
          }),
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        // If after_id is used: merge only new rows
        const newRows = json.data || [];

        // If you still want to rebuild from scratch, that’s fine,
        // but incremental append into your existing `messages` is cheaper:
        // 1) convert newRows -> the same grouped shape as you do now
        // 2) merge into state

        // Update cursors
        if (json.last_id) setAfterId(json.last_id);
        if (json.server_time) setSince(json.server_time);

        // (keep your existing grouping exactly as you have it)
        // const grouped = ... your existing reduce() ...
        // setMessages(grouped);
        const grouped = [...(json.data ?? [])].reduce((acc, current) => {
          const existingMobile = acc.find(
            (item) => item.mobile === current.mobile
          );
          if (existingMobile) {
            existingMobile.message.push({
              id: current.id,
              text: current.message,
              created_at: current.created_at,
              recevied: current.received,
            });
          } else {
            acc.push({
              mobile: current.mobile,
              entity_name: current.entity_name,
              message: [
                {
                  id: current.id,
                  text: current.message,
                  created_at: current.created_at,
                  recevied: current.received,
                },
              ],
            });
          }
          return acc;
        }, []);

        // Merge grouped into existing messages (to avoid rebuilding entire state)
        setMessages((prev) => {
          const next = [...prev];
          let changed = false;
          for (const g of grouped) {
            const i = next.findIndex((x) => x.mobile === g.mobile);
            if (i >= 0) {
              const existingIds = new Set(
                (next[i].message || []).map((msg) => msg.id)
              );

              const newMessages = g.message.filter(
                (msg) => !existingIds.has(msg.id)
              );

              if (newMessages.length) {
                next[i] = {
                  ...next[i],
                  entity_name: g.entity_name ?? next[i].entity_name,
                  message: [...next[i].message, ...newMessages],
                };
                changed = true;
              }
            } else {
              next.push(g);
              changed = true;
            }
          }
          // keep same sort
          next.sort((a, b) => {
            const aDate = a.message.length
              ? new Date(a.message[a.message.length - 1].created_at)
              : new Date(0);
            const bDate = b.message.length
              ? new Date(b.message[b.message.length - 1].created_at)
              : new Date(0);
            return bDate - aDate;
          });
          return changed ? next : prev;
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMessage();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getMessage();
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    // Access the current property of the ref to get the DOM element
    const scrollContainer = scrollContainerRef.current;

    if (activeConversation) {
      if (
        scrollContainerRef &&
        scrollContainer &&
        scrollContainer.scrollHeight
      ) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }
    // Set scrollTop to the maximum scroll height
  }, [messages, activeConversation]); // Run the effect only once on mount

  return (
    <div
      style={{
        height: "calc(100% - 80px)",
        width: "calc(100% - 40px)",
        marginLeft: "20px",
        background: "red",
        background:
          "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
        padding: "20px",
        borderRadius: "10px",
        marginTop: "5px",
        display: "flex",
        gap: "5px",
        alignItems: "flex-start",
        justifyContent: "space-around",
      }}
    >
      <div
        style={{
          width: screenWidth > 1200 ? "24%" : "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "5px",
            gap: "5px",
            marginBottom: "15px",
          }}
        >
          <WhatsAppIcon style={{ fontSize: "30px", color: "#1a5737" }} />
          <div
            style={{
              color: "#1a5737",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
            }}
          >
            Your Whatsapp
          </div>
        </div>
        <div
          style={{
            position: "relative",
            background: "rgba(255,255,255,0.6)",
            color: "rgba(70,70,70)",
            borderRadius: "10px",
            width: "100%",
            marginBottom: "10px",
          }}
        >
          <input
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search conversations"
            style={{
              background: "transparent",
              border: "none",
              outline: "none",
              padding: "10px",
              width: "92%",
            }}
          />
          <SearchIcon
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translate(0%,-50%)",
            }}
          />
        </div>
        <div
          style={{
            height: "78%",
            display: "flex",
            flexDirection: "column",
            justifyContent: messages.length > 0 ? "flex-start" : "center",
            alignItems: "flex-start",
          }}
        >
          {messages.length > 0 ? (
            messages
              .filter((mes) => {
                const lowercasedQuery = searchQuery.toLowerCase();
                return (
                  mes?.mobile?.toLowerCase().includes(lowercasedQuery) ||
                  mes?.entity_name?.toLowerCase().includes(lowercasedQuery)
                );
              })
              .map((mes, index) => (
                <div
                  key={index}
                  className="mui_button"
                  style={{
                    width: "100%",
                    display:
                      (showArchive === false && mes.archive === 1) ||
                      (showArchive === false && mes.archive === true)
                        ? "none"
                        : "flex",
                    color:
                      activeConversation === index ? "white" : "rgba(80,80,80)",
                    marginBottom: "10px",
                    position: "relative",
                  }}
                >
                  <div
                    onClick={() => {
                      const messageIndex = messages.findIndex(
                        (mess) => mess.mobile === mes.mobile
                      );
                      setActiveConversation(messageIndex);
                    }}
                    style={{
                      background:
                        mes.archive === true || mes.archive === 1
                          ? "rgba(230,230,230,1)"
                          : activeConversation === index
                          ? "#1a5737"
                          : "rgba(255,255,255,1)",
                      borderRadius: "10px",
                      padding: "10px 15px",
                      width:
                        mes.receiver !== "ALL" &&
                        mes.receiver !== "AB" &&
                        mes.receiver !== "AL" &&
                        messageHover === index
                          ? "85%"
                          : "100%",
                      height: "100%",
                      position: "relative",
                      cursor: "pointer",
                      transition: "0.3s all ease-in-out",
                      zIndex: 1,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ fontSize: "14px" }}>
                        {mes.entity_name
                          ? `${mes.entity_name.slice(0, 15)}... (+${
                              mes.mobile
                            })`
                          : mes.mobile}
                      </div>
                      <div
                        style={{
                          color:
                            activeConversation === index
                              ? "white"
                              : "rgba(0,0,0,0.4)",
                          fontSize: "10px",
                        }}
                      >
                        {mes.message
                          ? mes.message.length > 0
                            ? convertDateString(
                                mes.message[mes.message.length - 1].created_at
                              ).time
                            : ""
                          : ""}
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color:
                          activeConversation === index
                            ? "white"
                            : "rgba(0,0,0,0.4)",
                      }}
                    >
                      {mes.message
                        ? mes.message.length > 0
                          ? mes.message[mes.message.length - 1].text?.length >
                            40
                            ? mes.message[mes.message.length - 1].text.slice(
                                0,
                                40
                              ) + "..."
                            : mes.message[mes.message.length - 1].text
                          : ""
                        : ""}
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <UpcomingIcon
                  style={{ fontSize: "120px", color: "rgba(130,130,130)" }}
                />
              </div>
              <div style={{ color: "rgba(150,150,150)", fontSize: "15px" }}>
                No messages found
              </div>
            </div>
          )}
        </div>
      </div>
      <>
        <hr
          style={{
            background: "rgba(255,255,255,0.9)",
            border: "none",
            outline: "none",
            width: "2.5px",
            height: "95%",
          }}
        />
        <div
          style={{
            width: "70%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: messages[activeConversation]
              ? "flex-start"
              : "center",
          }}
        >
          {messages[activeConversation] ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                color: "rgba(70,70,70)",
              }}
            >
              <div
                ref={scrollContainerRef}
                style={{ height: "calc(100% - 50px)", overflowY: "auto" }}
              >
                {messages[activeConversation].message
                  ? messages[activeConversation].message.map((convo, index) => (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: convo.recevied
                            ? "flex-start"
                            : "flex-end",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px 10px 25px 10px",
                            borderRadius: "10px",
                            background: convo.recevied
                              ? "rgba(255,255,255,0.8)"
                              : "#1a5737",
                            marginBottom: "10px",
                            color: convo.recevied ? "inherit" : "white",
                            minWidth: "30%",
                            maxWidth: "75%",
                            position: "relative",
                          }}
                        >
                          {convo.text}
                          <div
                            style={{
                              position: "absolute",
                              bottom: "7px",
                              right: "10px",
                              fontSize: "10px",
                              color: convo.recevied
                                ? "rgba(0,0,0,0.4)"
                                : "rgba(255,255,255,0.6)",
                            }}
                          >
                            {convertDateString(convo.created_at).time +
                              ",  " +
                              convertDateString(convo.created_at).date}
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log(messageInput, activeConversation);
                  if (
                    messageInput !== "" &&
                    messageInput !== null &&
                    activeConversation !== null
                  ) {
                    sendMessage();
                    setMessageInput("");
                  }
                }}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  position: "relative",
                  background: "rgba(255,255,255,0.8)",
                  borderRadius: "10px",
                }}
              >
                <input
                  ref={inputRef}
                  placeholder="Type your message here"
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  style={{
                    outline: "none",
                    border: "none",
                    background: "transparent",
                    padding: "12px 8px 12px 15px",
                    borderRadius: "10px",
                    width: "95%",
                    position: "relative",
                    zIndex: 1,
                  }}
                />
                <button
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    right: "10px",
                    outline: "none",
                    border: "none",
                    background: "transparent",
                  }}
                  type="Submit"
                >
                  <SendIcon />
                </button>
              </form>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <UpcomingIcon
                  style={{ fontSize: "120px", color: "rgba(130,130,130)" }}
                />
              </div>
              <div style={{ color: "rgba(150,150,150)", fontSize: "15px" }}>
                No conversation selected
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default AdminWhatsapp;
